import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import './assets/fonts/Google-Sans/ProductSans-Regular.woff';
import './assets/fonts/Montserrat/Montserrat-VariableFont_wght.ttf';
import './assets/fonts/Poppins/Poppins-Regular.ttf';

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,

    document.getElementById('root')
);
